import React from "react";
import bbb from "../images/modalImage1.png";
import ccc from "../images/modalImage2.png";
import registry_img from '../images/Uso Personal y Doméstico_5 .8a875c2710db65ee0ae4 1.png'
import seach_img from '../images/imagen_nosotros.942f36cbe61b09bf0780 1.png'
import './Modal.css'
import { useLanguage } from "../Providers/LanguageContext";
export default function InvestmentRegistry({
  closeModal,
  registerClick,
  searchClick,
}) {
  const { language, currentLanguage } = useLanguage();

  return (
    <>
      <div className="RegisterInvest d-none">
        <div className="modal-content w-fc">
          <span
            className="close pl-05"
            style={{ cursor: "pointer" }}
            onClick={() => closeModal()}
          >
            ×
          </span>
          <div className="p-1 g-2-1fr">
            <span
              className="registerButton"
              onClick={() => {
                registerClick();
                closeModal();
              }}
            >
              <h2>{language.reg_inv}</h2>
              <div style={{ width: 225 }} className="modalImageContainer">
                <img
                  style={{ width: "100%" }}
                  src={bbb}
                  alt="register investment"
                  className=""
                />
                <div className="position-absolute top-0 left-0 p-3">
                  <p className="w-50 blueText">
                    <span className="bigText">{currentLanguage === 'eng' ? "REGISTER" : "REGISTRO"} </span>
                    {currentLanguage === 'eng' ? "Investment" : "Inversión"}
                  </p>

                </div>
              </div>
            </span>
            <span
              className="registerButton"
              onClick={() => {
                searchClick();
                closeModal();
              }}
            >
              <h2>{language.search_investment}</h2>
              <div style={{ width: 225 }} className="modalImageContainer">
                <img
                  style={{ width: "100%" }}
                  src={ccc}
                  alt="search investment"
                />
                <div className="position-absolute top-0 left-0 p-3">
                  <p className="w-50 blueText">
                    <span className="bigText">{currentLanguage === 'eng' ? "SEARCH" : "BUSCAR"}</span> {currentLanguage === 'eng' ? "Investment" : "Inversión"}
                  </p>
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>

      <div className="registry_modal_wrapper" onClick={(()=>{
          closeModal();
      })}></div>
      <div className="registry_modal_div_wrapper">

        <div className="registry_modal_left">
          <h2>{currentLanguage === 'eng' ? "REGISTER" : "REGISTRO"}  {currentLanguage === 'eng' ? "Investment" : "Inversión"}</h2>
          <div className="click_here_button_div">
            <button onClick={() => {
              registerClick();
              closeModal();
            }} >Click Here</button>
          </div>
        </div>
        <div className="registry_modal_right">
          <img src={registry_img} />
        </div>
      </div>


      <div className="search_modal_div_wrapper">

        <div className="registry_modal_right">
          <img src={seach_img} />
        </div>

        <div className="registry_modal_left">
          <h2>{currentLanguage === 'eng' ? "SEARCH" : "BUSCAR"}  {currentLanguage === 'eng' ? "Investment" : "Inversión"}</h2>
          <div className="click_here_button_div">
            <button onClick={() => {
              searchClick();
              closeModal();
            }}>Click Here</button>
          </div>
        </div>
      </div>
    </>
  );
}
